import { render, staticRenderFns } from "./lawyer_detial.vue?vue&type=template&id=13cb2a38&scoped=true"
import script from "./lawyer_detial.vue?vue&type=script&lang=js"
export * from "./lawyer_detial.vue?vue&type=script&lang=js"
import style0 from "./lawyer_detial.vue?vue&type=style&index=0&id=13cb2a38&prod&scoped=true&lang=less"
import style1 from "./lawyer_detial.vue?vue&type=style&index=1&id=13cb2a38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb2a38",
  null
  
)

export default component.exports